import { serviceLocator } from '@/utils/providers/serviceLocator'
import { BranchRepository } from '../repositories/BranchRepository'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'
import type { BranchFilterEntity } from '../entities/BranchFilterEntity'
import { useBranchStore } from '../../presentation/stores/branchStore'

export async function getBranchesCase(filterData: BranchFilterEntity, skipStore = false) {
  const newRepository = serviceLocator.getService<BranchRepository>('BranchService')
  const branchStore = useBranchStore()

  const { data } = await useQuery({
    fetcher: async () => await newRepository?.getBranches(filterData),
    key: 'branch',
    filterData: JSON.stringify(filterData)
  })
  if (data.value?.error) return
  if (!skipStore) branchStore.setBranches(data.value)
  return data.value
}
